export class AppSettings {
    //public static API_ENDPOINT = 'http://NOTHING_YET/api/';
    public static API_ENDPOINT = 'https://services-sarsis.azurewebsites.net/api/';
}